import { render, staticRenderFns } from "./ResearchRow.vue?vue&type=template&id=17e0f641&scoped=true&"
import script from "./ResearchRow.vue?vue&type=script&lang=js&"
export * from "./ResearchRow.vue?vue&type=script&lang=js&"
import style0 from "./ResearchRow.vue?vue&type=style&index=0&id=17e0f641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e0f641",
  null
  
)

export default component.exports